module.exports = __webpack_public_path__ + "static/media/folha5.72636d68.png";